import { getAuthorizationHeader } from "../../utils/authentication";
import { get, post } from "../axiosClient";
import { Endpoint } from "../endpoint";
import {
  LuckyDrawCurrentResponse,
  LuckyDrawLastRoundResponse,
  LuckyDrawNextDrawResponse,
  LuckyDrawRulesResponse,
  TopWinnersRequest,
  TopWinnersResponse,
  TicketSoldDetailsRequest,
  TicketSoldDetailsResponse,
  BuyTicketsRequest,
  BuyTicketsResponse,
  SearchRoundsRequest,
  SearchRoundsResponse,
  MyTicketsRequest,
  MyTicketsResponse,
  MyRoundsRequest,
  MyRoundsResponse,
  ReferralStatsResponse,
  ReferralLinkResponse,
  ClaimAwardPrizeRequest,
  ClaimAwardPrizeResponse,
  MyReferralResponse,
  RoundsSummaryResponse,
} from "./types";

const luckyDrawServices = {
  // Public endpoints
  getCurrentRound(): Promise<LuckyDrawCurrentResponse> {
    return get(Endpoint.LUCKY_DRAW_CURRENT, {
      headers: getAuthorizationHeader(),
    });
  },

  getLastRound(): Promise<LuckyDrawLastRoundResponse> {
    return get(Endpoint.LUCKY_DRAW_LAST_ROUND, {
      headers: getAuthorizationHeader(),
    });
  },

  getNextDraw(): Promise<LuckyDrawNextDrawResponse> {
    return get(Endpoint.LUCKY_DRAW_NEXT_DRAW, {
      headers: getAuthorizationHeader(),
    });
  },

  getRules(): Promise<LuckyDrawRulesResponse> {
    return get(Endpoint.LUCKY_DRAW_RULES, {
      headers: getAuthorizationHeader(),
    });
  },

  getTopWinners(
    params: TopWinnersRequest
  ): Promise<TopWinnersResponse> {
    return post(Endpoint.LUCKY_DRAW_TOP_WINNERS, params, {
      headers: getAuthorizationHeader(),
    });
  },

  getTicketSoldDetails(
    params: TicketSoldDetailsRequest
  ): Promise<TicketSoldDetailsResponse> {
    return post(Endpoint.LUCKY_DRAW_TICKET_SOLD_DETAILS, params, {
      headers: getAuthorizationHeader(),
    });
  },

  searchRounds(
    params?: SearchRoundsRequest
  ): Promise<SearchRoundsResponse> {
    return post(Endpoint.LUCKY_DRAW_ROUNDS_SEARCH, params, {
      headers: getAuthorizationHeader(),
    });
  },

  getRoundsSummary(): Promise<RoundsSummaryResponse> {
    return get(Endpoint.LUCKY_DRAW_ROUNDS_SUMMARY, {
      headers: getAuthorizationHeader(),
    });
  },

  // Authenticated endpoints
  buyTickets(
    params: BuyTicketsRequest
  ): Promise<BuyTicketsResponse> {
    return post(Endpoint.LUCKY_DRAW_BUY, params, {
      headers: getAuthorizationHeader(),
    });
  },

  getMyTickets(
    params: MyTicketsRequest
  ): Promise<MyTicketsResponse> {
    return post(Endpoint.LUCKY_DRAW_MY_TICKETS, params, {
      headers: getAuthorizationHeader(),
    });
  },

  getMyRounds(
    params: MyRoundsRequest
  ): Promise<MyRoundsResponse> {
    return post(Endpoint.LUCKY_DRAW_MY_ROUNDS, params, {
      headers: getAuthorizationHeader(),
    });
  },

  getReferralStats(): Promise<ReferralStatsResponse> {
    return get(Endpoint.LUCKY_DRAW_REFERRAL_STATS, {
      headers: getAuthorizationHeader(),
    });
  },

  getReferralLink(): Promise<ReferralLinkResponse> {
    return get(Endpoint.LUCKY_DRAW_REFERRAL_LINK, {
      headers: getAuthorizationHeader(),
    });
  },

  claimAwardPrize(
    params: ClaimAwardPrizeRequest
  ): Promise<ClaimAwardPrizeResponse> {
    return post(Endpoint.LUCKY_DRAW_CLAIM, params, {
      headers: getAuthorizationHeader(),
    });
  },

  getMyReferrals(): Promise<MyReferralResponse> {
    return post(Endpoint.LUCKY_DRAW_MY_REFERRAL, {
      headers: getAuthorizationHeader(),
    });
  },
};

export default luckyDrawServices;
